import * as React from "react";
import { styled } from "@mui/system";
import { TreeItem as VaporTreeItem } from "@vapor/x-treeview/TreeItem";
import { TreeItemProps as VaporTreeItemProps } from "@vapor/x-treeview/TreeItem";

interface TreeItemProps extends VaporTreeItemProps {
  level?: number;
}

export const AnchorMenuItem = styled(
  ({ children, level = 1, ...restProps }: TreeItemProps) => {
    return (
      <VaporTreeItem {...restProps}>
        {React.Children.map(
          children,
          (child: React.ReactElement, childIndex: number) => {
            if (
              (child.type as React.ComponentType).displayName ===
              AnchorMenuItem.displayName
            ) {
              return React.cloneElement(child, {
                level: level + 1
              });
            }
            return child;
          }
        )}
      </VaporTreeItem>
    );
  },
  {
    name: "AnchorMenuItem",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme, level = 1 }) => {
  console.log("level on css: ", level);

  return {
    "&.MuiTreeItem-root .MuiTreeItem-content": {
      flexDirection: "row-reverse",
      "&.Mui-selected": {
        background: theme.palette.primary.interactiveSelectedColor,
        boxShadow: "2px 0px 0px 0px #008BCC inset",
        "& .MuiTreeItem-label": {
          color: theme.palette.primary.textTitleColor,
          fontWeight: 500
        }
      },
      "&:hover": {
        border: "1px solid " + theme.palette.primary.borderActive
      },
      "&.MuiTreeItem-content .MuiTreeItem-label": {
        fontSize: 14,
        color: theme.palette.primary.textDefault,
        fontFamily: "Roboto",
        fontWeight: 400
      },
      "&.MuiTreeItem-root .MuiTreeItem-content .MuiTreeItem-iconContainer": {
        color: theme.palette.primary.main,
        alignItems: "center",
        width: 32,
        height: 32
      }
    },
    "&.MuiTreeItem-root .MuiCollapse-root.MuiTreeItem-group": {
      marginLeft: 0,
      "& .MuiTreeItem-label": {
        paddingLeft: `calc(${level} * 16px)`
      }
    }
  };
});
